import ApplicationSerializer from 'admin-panel/serializers/application';

import type Model from '@ember-data/model';

export default class RoomControlConfigTvChannelSerializer extends ApplicationSerializer {
  normalize(typeClass: Model, hash: Record<string, unknown>, _prop: string) {
    hash['room_control_configuration_id'] = hash['configuration_id'];
    delete hash['configuration_id'];

    hash['room_control_tv_channel_id'] = hash['tv_channel_id'];
    delete hash['tv_channel_id'];

    return super.normalize(typeClass, hash, _prop);
  }
}

declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'room-control/config-tv-channel': RoomControlConfigTvChannelSerializer;
  }
}
